import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNilty } from '@core/utils.service';
import { Operation } from '@models/operation-model';
import { fromDateToString, stringToDate } from '@models/date-converter';

@Component({
  selector: 'app-partner-send-error-modal',
  templateUrl: './partner-send-error-modal.component.html',
  styleUrls: ['./partner-send-error-modal.component.css'],
})
export class PartnerSendErrorModalComponent {
  operationId: string;
  documentNumber: string;
  status: string;
  error: string;
  recordedAt: string;

  constructor(
    public dialogRef: MatDialogRef<PartnerSendErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Operation,
  ) {
    this.error = this.data.data?.partnerSendErrorMessage as string;
    this.operationId = this.data.data?.operationId as string;
    this.documentNumber = this.data.documentNumber;
    this.status = this.data.status;
    this.recordedAt = this.formatRecordedAt(this.data.data?.partnerSendErrorAt);
  }

  private formatRecordedAt(value: unknown): string {
    if (isNilty(value)) {
      return null;
    }
    if (value instanceof Date) {
      return fromDateToString(value);
    }
    if (typeof value === 'string') {
      const parsed = stringToDate(value) ?? new Date(value);
      return Number.isNaN(parsed.getTime()) ? value : fromDateToString(parsed);
    }
    if (typeof value === 'number') {
      return fromDateToString(new Date(value));
    }
    return String(value);
  }

  close() {
    this.dialogRef.close();
  }
}
